import SaveForLaterPortal from "../saveForLaterPortal/SaveForLaterPortal";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import SaveCount from "../../components/saveCount/SaveCount";
import LooksButton from "../../components/looks/LooksButton";
import WaysToStyleGalleryButton from "../../components/waysToStyle/WaysToStyleGalleryButton";
import MixAndMatchPaymentPromoContainer from "../mixAndMatchPaymentPromoContainer/MixAndMatchPaymentPromoContainer";
import MixAndMatchRatingsContainer from "../mixAndMatchRatingsContainer/mixAndMatchRatingsContainer";
import { useStockPrice } from "../../context/stockPrice/StockPriceContext";
import ReleaseDateBannerPortal from "../releaseDateBannerPortal/ReleaseDateBannerPortal";
import {
  useWaysToStyle,
  isWaysToStyleFeatureEnabled,
} from "../../context/waysToStyle/WaysToStyleContext";

export default function ReactPortals() {
  const { products } = useStockPrice();
  const { isMixAndMatch, isMobile } = useRuntimeConstants();
  const { stylingLooks, shouldShowWaysToStyle } = useWaysToStyle();
  const showWaysToStyleButton =
    isMobile &&
    isWaysToStyleFeatureEnabled() &&
    shouldShowWaysToStyle &&
    stylingLooks.length > 0;

  const renderMixAndMatchSaveButton = () => {
    return products.products
      .filter(({ variants }) => variants.length)
      .map((productItem) => (
        <SaveForLaterPortal
          product={productItem}
          key={`save-product-${productItem.id}`}
        />
      ));
  };

  const renderMainSaveButton = () => {
    if (products) {
      return isMixAndMatch && renderMixAndMatchSaveButton();
    }
  };

  return (
    <>
      <SaveCount />
      <MixAndMatchPaymentPromoContainer />
      <MixAndMatchRatingsContainer />
      {showWaysToStyleButton ? <WaysToStyleGalleryButton /> : <LooksButton />}
      <ReleaseDateBannerPortal />
      {renderMainSaveButton()}
    </>
  );
}
